import request from '@/utils/http';
import { SRM, PFX } from '../constant/constant.js';
// 保存基本信息
export const savePhysicalBasicInfo = (params) => {
    return request({
        url: `${SRM}/insertSupplierPhysicsWarehouseInfoVo`,
        method: 'post',
        data: params,
        headers: {
            'Content-Type': 'application/json'
        }
    });
};
// 保存图片
export const savePhysicalImg = (params) => {
    return request({
        url: `${SRM}/saveAndUpdateImages`,
        method: 'post',
        data: params,
        headers: {
            'Content-Type': 'application/json'
        }
    });
};
// 查询仓库资质
export const searchQualification = (params) => {
    return request({
        url: `${SRM}/queryPwQualification?whCode=` + params,
        method: 'get'
    });
};
// 查询仓库信息详情
export const searchPhysicalDetail = (params) => {
    return request({
        url: `${SRM}/supplierPhysicsWarehouse/` + params,
        method: 'get'
    });
};
// 查询仓库图片
export const searchImages = (params) => {
    return request({
        url: `${SRM}/queryPwImages?whCode=` + params,
        method: 'get'
    });
};
// 上传资质
export const uploadQualification = (params) => {
    return request({
        url: `${SRM}/supplierQualificationInfo/insertUpdate`,
        method: 'post',
        data: params,
        headers: {
            'Content-Type': 'application/json'
        }
    });
};
// // 新增资质
// export const addQualificationInfo = (params) => {
//     return request({
//         url: `${SRM}/supplierQualificationInfo/insertCustomWareHouse`,
//         method: 'post',
//         data: params,
//         headers: {
//             'Content-Type': 'application/json'
//         }
//     });
// };
// 新增资质
export const addPhysicsQua = data => {
    return request({
        url: `${SRM}/supplierQualificationInfo/addPhysics`,
        method: 'post',
        data
    });
};

// // 删除资质
// export const delQualification = (params) => {
//     return request({
//         url: `${SRM}/supplierQualificationInfo/batchDelete`,
//         method: 'post',
//         data: params,
//         headers: {
//             'Content-Type': 'application/json'
//         }
//     });
// };

// 删除资质
export const deletePhysics = data => {
    return request({
        url: `${SRM}/supplierQualificationInfo/deletePhysics`,
        method: 'post',
        data
    });
};

// MIP申请
export const MipExamine = (params) => {
    return request({
        url: `${SRM}/commitMipExamine`,
        method: 'post',
        data: params,
        headers: {
            'Content-Type': 'application/json'
        }
    });
};
// 删除物理仓
export const delPhysicalStorage = (whCode, params = {}) => {
    return request({
        url: `${SRM}/supplierPhysicsWarehouse/${whCode}`,
        method: 'delete',
        data: params,
        headers: {
            'Content-Type': 'application/json'
        }
    });
};

// 流程信息
export const getProcessList = (params = {}) => {
    return request({
        url: `${SRM}/queryMipAuditByWhCode`,
        method: 'get',
        params: params
    });
};

// 查询子仓库列表
export const searchWarehouseSons = (data) => {
    return request({
        url: `${SRM}/searchPhysicsWarehouseSons`,
        method: 'post',
        data
    });
};

// 查询子仓库详情
export const getWarehouseSon = (data) => {
    return request({
        url: `${SRM}/supplierPhysicsWarehouseSon/${data}`,
        method: 'get'
    });
};

// 新增子仓库
export const addWarehouseSons = (data) => {
    return request({
        url: `${SRM}/supplierPhysicsWarehouseSon`,
        method: 'post',
        data
    });
};

// 编辑子仓库
export const editWarehouseSons = (data) => {
    return request({
        url: `${SRM}/supplierPhysicsWarehouseSon/${data.id}`,
        method: 'put',
        data
    });
};

// 删除子仓库
export const delWarehouseSons = (data) => {
    return request({
        url: `${SRM}/supplierPhysicsWarehouseSon/${data}`,
        method: 'delete'
    });
};

// 物理仓-消防分区-查询
export const getFireZones = (data) => {
    return request({
        url: `${PFX}/supplierPhysicsWarehouseFireZones`,
        method: 'post',
        data
    });
};

// 物理仓-消防分区-新增
export const addFireZone = (data) => {
    return request({
        url: `${PFX}/supplierPhysicsWarehouseFireZone`,
        method: 'post',
        data
    });
};
// 物理仓-消防分区-编辑
export const editFireZone = (data) => {
    return request({
        url: `${PFX}/supplierPhysicsWarehouseFireZone/${data.id}`,
        method: 'put',
        data
    });
};

// 物流园-资质附件新增（无仓库编码的时候）
export const queryPwQualificationQueryCondition = data => {
    return request({
        url: `${SRM}/supplierPhysicsWarehouse/queryPwQualificationQueryCondition`,
        method: 'post',
        data,
    });
};

// 物流园-物理仓变更流程审批申请提交
export const changeApply = data => {
    return request({
        url: `${SRM}/supplierPhysicsWarehouse/changeApply`,
        method: 'post',
        data,
    });
};

// 物理仓变更流程-变更前后信息
export const changeApplyInfoIFlow = params => {
    return request({
        url: `${SRM}/supplierPhysicsWarehouse/changeApplyInfoIFlow`,
        method: 'get',
        params,
    });
};
